export default __webpack_public_path__ + "static/thomas_farr_logo-4d960f346cdfbedf189dc2b9a244aad8.png";